export default "__VITE_ASSET__BcYW56bV__"